import { render, staticRenderFns } from "./caret-up.vue?vue&type=template&id=01e05533&"
import script from "./caret-up.vue?vue&type=script&lang=js&"
export * from "./caret-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports